import { render, staticRenderFns } from "./ClientsPage.vue?vue&type=template&id=ff165b68&"
import script from "./ClientsPage.vue?vue&type=script&lang=js&"
export * from "./ClientsPage.vue?vue&type=script&lang=js&"
import style0 from "./ClientsPage.vue?vue&type=style&index=0&id=ff165b68&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports